import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { images } from 'app/constants/images';

import ErrorPageUI from './ErrorPageUI';

// Component Definition
const Whoops: FC = () => {
  const { t } = useTranslation();

  return (
    <ErrorPageUI
      alt="Yield Sign"
      backgroundImage={images.yieldSign.full}
      backgroundImageLoader={images.yieldSign.compressed}
      heading={t('common:whoops.heading', 'Whoops!')}
      linkTitle={t('common:returnToHome', 'Return to home')}
      subheading={t('common:whoops.subheading', 'Something\'s gone wrong.')}
      withNavBar
    />
  );
};

export default Whoops;
